function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 35 35"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.929 14.493L32.828 2.74 21.585 6.758l.83 2.326 6.622-2.366-8.447 12.67-9.442-4.969L.015 29.129l1.97 1.49 9.867-13.038 9.558 5.03 9.826-14.739 1.261 7.056 2.432-.435z",
  fill: "#354147"
})));